export default {
  props: {
    campaign: Object,
  },
};



// WEBPACK FOOTER //
// ./src/components/campaign-heading/CampaignHeading.js